const newArea = {
  snackbar: "Su actualización esta completada",
  name: "Nombre de Edifico",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Edificio",
  formTitle: "Nuevo Edificio",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar",
  selectCompany: "Selecciona una Compañía"
};
export default newArea;
